import { Spacing } from '@persona-id/design-tokens';
import { useState } from 'react';
import styled from 'styled-components';

import ConnectedAccountStatusSelect from 'dashboard/components/ConnectedAccountStatusSelect.tsx';
import ConnectedConditionsSelect from 'dashboard/components/ConnectedConditionsSelect';
import ConnectedTagSelect from 'dashboard/components/ConnectedTagSelect';
import Form from 'dashboard/layouts/FormLayout/Form';
import { ColorRule } from 'dashboard/models/graph';
import Button from 'design-system/components/Button';
import Select, { Option } from 'design-system/components/Select';
import { ApiModel } from 'lib/interfaces/api';
import { assertNever } from 'lib/utils/types';

export interface FormCreateGraphColorRuleData {
  type: ColorRule['type'];
  colorRuleValue: string;
}

interface FormCreateGraphColorRuleProps {
  onSubmit: (type: ColorRule['type'], colorRuleValue: string) => void;
}

const SaveButton = styled(Button)`
  width: 75px;
  display: inline-block;
  margin-top: ${Spacing[4]};
`;

const StyledSelectContainer = styled.div`
  margin: ${Spacing[4]} 0px;
`;

const CreateGraphColorRuleField = ({ onSubmit }: FormCreateGraphColorRuleProps) => {
  const [type, setType] = useState<ColorRule['type']>('tag');
  const [colorRuleValue, setColorRuleValue] = useState('');

  const renderSelectComponent = () => {
    switch (type) {
      case 'tag': {
        return (
          <ConnectedTagSelect
            value={[colorRuleValue]}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            onChange={(newTag) => setColorRuleValue(newTag.pop())}
            tagScope={ApiModel.Account}
            returnName={true}
          />
        );
      }
      case 'status': {
        return (
          <ConnectedAccountStatusSelect
            value={colorRuleValue}
            onChange={(newStatus) => setColorRuleValue(newStatus)}
            returnName={true}
          />
        );
      }
      case 'condition': {
        return (
          <ConnectedConditionsSelect
            value={colorRuleValue}
            onChange={(newCondition) => setColorRuleValue(newCondition)}
            returnName={true}
          />
        );
      }
      default:
        assertNever(type);
    }
  };

  return (
    <Form>
      <Select
        onValueChange={(value) => {
          setType(value as ColorRule['type']);
          setColorRuleValue('');
        }}
        portal={false}
        value={type}
      >
        <Option value='tag'>Tag</Option>
        <Option value='status'>Status</Option>
        <Option value='condition'>Condition</Option>
      </Select>
      <StyledSelectContainer>{renderSelectComponent()}</StyledSelectContainer>
      <SaveButton
        disabled={!colorRuleValue?.length}
        onClick={() => onSubmit(type, colorRuleValue)}
        id='graph__create_color_rule_save'
      >
        Save
      </SaveButton>
    </Form>
  );
};

export default CreateGraphColorRuleField;
